// src/index.tsx
import React      from 'react'
import ReactDOM   from 'react-dom/client'
import './index.css'
import App        from './app/App'
import reportWebVitals from './reportWebVitals'

import { installBffDisconnectFetchInterceptor } from '@/lib/http/bffFetchInterceptor';

import { AdapterDateFns }      from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers'

import { DevMobileEmulator, useDevMobileMode } from '@/shared/components/DevMobileEmulator';

installBffDisconnectFetchInterceptor();

/** Thin wrapper that conditionally activates the phone emulator in dev. */
function Root() {
  const { active } = useDevMobileMode();

  const app = (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <App />
    </LocalizationProvider>
  );

  if (active) {
    return <DevMobileEmulator>{app}</DevMobileEmulator>;
  }
  return app;
}

const root = ReactDOM.createRoot(document.getElementById('root')!)
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
)

// performance (optional)
reportWebVitals()
